module.exports = __webpack_public_path__ + "img/체력.d882a8db.svg";